import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

/**
 * Drawer「スキル登録」タブ (設計書§3-2/§3-3)。
 *
 * v0.5 実機フィードバックに基づく表示刷新 (docs/design/v05-skill-registration-table-redesign-detail.md
 * §8-2 項目3): Drawer内の横幅が狭くスキル登録表を読みにくいという実機フィードバックを受け、表を
 * Drawer内にインライン描画するのをやめ、横幅の広い専用ページ (`EmployeeDetailPage`「スキル・人材像」
 * タブ) へのリンク遷移に変更した。react-router の `<Link>` によるページ遷移は Drawer を含む現在の
 * ルート (`/talent/dashboard` 等) 全体をアンマウントするため、「Drawerを閉じてから遷移する」動作が
 * 自然に実現される (他の Drawer タブに同種の遷移パターンが無かったため、EmployeesPage.tsx の行内
 * 「詳細」リンクと同じ Link 遷移方式に揃えた)。
 */
export function SkillRegistrationSection({ employeeId }: { employeeId: string }) {
  return (
    <div className="py-8 text-center space-y-3">
      <p className="text-sm text-text-sub">
        スキル登録は横幅の広い専用画面でご確認・編集いただけます。
      </p>
      <Link
        to={`/employees/${employeeId}?tab=skills`}
        className="inline-flex items-center gap-1.5 min-h-[44px] px-4 rounded border border-brand-red text-brand-red text-sm hover:bg-brand-red hover:text-white transition"
      >
        <ExternalLink size={14} aria-hidden />スキル登録を開く
      </Link>
    </div>
  );
}
